import React from 'react';
import { ThemeProvider } from 'styled-components';
import blueGrey from '@material-ui/core/colors/blueGrey';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
const NavThemeProvider = ({ children }) => {
    const theme = createTheme({
        palette: {
            primary: {
                main: '#fff'
            },
            secondary: {
                main: '#2196f3'
            }
        },
        overrides: {
            MuiListItem: {
                root: {
                    '&.active': { backgroundColor: blueGrey[100] }
                }
            }
        }
    });
    return (React.createElement(MuiThemeProvider, { theme: theme },
        React.createElement(ThemeProvider, { theme: theme }, children)));
};
export default NavThemeProvider;
//# sourceMappingURL=NavThemeProvider.js.map